import Base from './Base';

export default class ambraNamespace extends Base {
  value = '';
  label = '';

  constructor(props) {
    super();
    this.clone(props);
  }
}
